import {useSuspenseChildRouteQuery, useSuspenseRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsOverviewRoute} from '../../../routes/overview-route'

export const useAssigneesQuery = () => useSuspenseChildRouteQuery(pullRequestsOverviewRoute, 'assignees')
export const useReviewRequestsQuery = () => useSuspenseChildRouteQuery(pullRequestsOverviewRoute, 'review_requests')
export const useBaseComparisonInfoQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'base_comparison_info')
export const useActivityQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'catch_up')
